<template>
    <div>Main Page Content</div>
</template>

<script>
    export default {
        name: 'MainPage'
    }
</script>

<style></style>
